import { useEffect, useRef, useState, useCallback } from "react";

function useDealtHandCards  (
    cards,
    delay = 100,
    selectedCombinationCards = {},
    resetHand,
    playedCard,
    boardWinnerId,
    bitaDelay = 300
)  {
    const [handCards, setHandCards] = useState(
        Array.from({ length: 9 }, () => ({
            suit: null,
            rank: null,
            played: false,
            playable: false,
            bita: null,
            passed: false,
            priority: null
        }))
    );

    const [activeCardCount, setActiveCardCount] = useState(0);
    const [bitaCards, setBitaCards] = useState([]);

    const timeoutsRef = useRef([]);
    const dealtCardsLength = useRef(0);
    const bitaTimeoutRef = useRef(null);

    useEffect(() => {
        setHandCards(Array.from({ length: 9 }, () => ({
            suit: null,
            name: null,
            rank: null,
            played: false,
            playable: false,
            bita: null,
            passed: false
        })));
        setActiveCardCount(0);
        setBitaCards([]);
        dealtCardsLength.current = 0;
    }, [resetHand]);

    const resetBita = useCallback(() => {
        clearTimeout(bitaTimeoutRef.current);
        setBitaCards([]);
    }, []);

    useEffect(() => {
        if (!boardWinnerId) {
            resetBita();
            return;
        }
        if (playedCard == null) return;

        bitaTimeoutRef.current = setTimeout(() => {
            setBitaCards((prev) => [...prev, playedCard]);
        }, bitaDelay);

        return () => clearTimeout(bitaTimeoutRef.current);
    }, [playedCard, boardWinnerId, bitaDelay, resetBita]);

    useEffect(() => {
        if (resetHand) return;
        if (dealtCardsLength.current === 9) {
            let visualIndex = 0;

            const updatedHand = cards.map((card, i) => {
                const isRemoved = card?.played || card?.bita;
                const assignedIndex = isRemoved ? i + 1 : visualIndex++;
                const inCombination = selectedCombinationCards[card?.name] !== undefined;

                return {
                    ...card,
                    inHand: true,
                    index: assignedIndex,
                    inCombination,
                };
            });

            setHandCards(updatedHand);

            const filtered = cards.filter(
                (card) => !card.played && card.bita == null
            );
            setActiveCardCount(filtered.length);
        }
    }, [cards, selectedCombinationCards, resetHand]);

    useEffect(() => {
        if (resetHand) return;
        timeoutsRef.current.forEach(clearTimeout);
        timeoutsRef.current = [];

        if (cards.length !== 6 && cards.length !== 9) return;

        dealtCardsLength.current = cards.length;
        const instantCount = cards.length === 9 ? 6 : 0;
        let visualIndex = 0;

        const filtered = cards.filter(
            (card) => !card.played && card.bita == null
        );
        setActiveCardCount(filtered.length);

        cards.forEach((card, i) => {
            const isRemoved = card?.played || card?.bita;
            const assignedIndex = isRemoved ? i + 1 : visualIndex++;
            const inCombination = selectedCombinationCards[card?.name] !== undefined;

            const assignCard = () => {
                setHandCards((prev) => {
                    const updated = [...prev];
                    updated[i] = {
                        ...card,
                        inHand: true,
                        index: assignedIndex,
                        inCombination,
                    };
                    return updated;
                });
            };

            if (i < instantCount) {
                assignCard();
            } else {
                const timeoutId = setTimeout(assignCard, (i - instantCount) * delay);
                timeoutsRef.current.push(timeoutId);
            }
        });

        return () => {
            timeoutsRef.current.forEach(clearTimeout);
            timeoutsRef.current = [];
        };
    }, [cards.length, delay, selectedCombinationCards, resetHand]);

    return {
        handCards,
        activeCardCount,
        bitaCards,
        resetBita
    };
}
export default useDealtHandCards